import BaseResponsiveContainer from "../../sisu/chart/BaseResponsiveContainer.sisu";

const NeoResponsiveContainer = (props)=>{
    return <BaseResponsiveContainer {...props}>
        {props.children}
    </BaseResponsiveContainer>
}

export default NeoResponsiveContainer;